import {LitElement, html} from 'lit';
import {createRef, ref} from 'lit/directives/ref.js';
import styles from './x-signature-capture.component.scss?as=stylesheet';
import SignaturePad from 'signature_pad';

// Need to review https://stackoverflow.com/questions/69380181/uppy-io-using-to-send-base64-encoded-data-rather-than-specifying-a-file-input
export class SignatureCapture extends LitElement {

	canvas = createRef();

	static styles = [styles];

	constructor () {
		super();
	}

	render () {
		return html`
			<canvas ${ref(this.canvas)}></canvas>
		`;
	}

	connectedCallback () {
		super.connectedCallback();

		window.addEventListener('resize', this.resizeCanvas);
	}

	disconnectedCallback () {
		window.removeEventListener('resize', this.resizeCanvas);

		super.disconnectedCallback();
	}

	firstUpdated () {
		let signaturePad = new SignaturePad(this.canvas.value, {
			backgroundColor: 'rgb(255, 255, 255)'
		});

		signaturePad.addEventListener('endStroke', () => {
			this.dispatchEvent(new CustomEvent('endStroke', {
				bubbles: true
			}));

			this.value = signaturePad.toDataURL();
		});

		this.resizeCanvas();
	}

	resizeCanvas () {
		if (!this.canvas?.value) {
			return;
		}

		const ratio = Math.max(window.devicePixelRatio || 1, 1);
		this.canvas.value.width = this.canvas.value.offsetWidth * ratio;
		this.canvas.value.height = this.canvas.value.offsetHeight * ratio;
		this.canvas.value.getContext('2d').scale(ratio, ratio);
	}
}

customElements.define('x-signature-capture', SignatureCapture);
